import { render } from "./MyScoreMap.vue?vue&type=template&id=b42e5d46"
import script from "./MyScoreMap.vue?vue&type=script&lang=js"
export * from "./MyScoreMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__